import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import Tag from './../components/tag';
import './styles.css';
// import { number } from 'prop-types';

import { connect } from 'react-redux';

class FilterContainer extends Component {
  render() {
    return (
      <Grid className='filter' >
        {
          this.props.filterArray.map((item) => <Tag dato={item} key={`filterTag-${item.name}-${item.id}-${item.value}`} />) 
        }
      </Grid>
    )
  }
}

function mapStateToProps(state) {
  return {
    filterArray: state.dashboard.filterArray
  }
}

export default connect(mapStateToProps)(FilterContainer);
